export default __webpack_public_path__ + "static/media/bloomberg.f790f9d3.svg";